import { useContext, useEffect, useState } from "react";

import { Image } from "capitalrx-components-2.0";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Bold, Heading } from "capitalrx-components-2.0/lib/typography";

import RequestModal from "@/components/GetCardModals/RequestModal";
import { RequestTypes } from "@/types/AdvantageCardRequest";
import { WhiteLabelButton } from "../Button/WhiteLabelButton";

import styles from "./WhiteLabelGetAdvantageCardCTA.module.scss";
import { ThemeSelectorContext } from "@/context";

export const GetAdvantageCard = () => {
  const [showModalState, setShowModalState] = useState(false);
  const [modalType, setModalType] = useState<RequestTypes>(RequestTypes.null);
  const [isMobile, setIsMobile] = useState(true);
  const { card } = useContext(ThemeSelectorContext);

  useEffect(() => {
    const handleResize = () => {
      const windowSize = window.outerWidth;
      if (windowSize < 992) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
    };
    window.addEventListener("load", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("load", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const showModal = (type: RequestTypes): void => {
    setModalType(type);
    setShowModalState(true);
  };

  const closeModal = (): void => {
    setShowModalState(false);
    return null;
  };

  const BulletText = () => {
    if (isMobile) {
      return (
        <p className={styles.WhiteLabelAdvantageCTABullets}>
          No membership fees <br /> No credit card required <br /> No expiration <br /> One card for the whole family
        </p>
      );
    }

    return (
      <p className={styles.WhiteLabelAdvantageCTABullets}>
        No membership fees &bull; No credit card required <br /> No expiration &bull; One card for the whole family
      </p>
    );
  };

  return (
    <Shelf className={styles.WhiteLabelAdvantageCTA}>
      <RequestModal type={modalType} visible={showModalState} onClose={closeModal} />
      <Stack spacing="medium-large" className={styles.WhiteLabelAdvantageCTALeft}>
        <Heading className={styles.WhiteLabelAdvantageCTAHeading}>Tired of overpaying for your medications?</Heading>
        <p className={styles.WhiteLabelAdvantageCTAText}>
          Download your <Bold>FREE</Bold> savings card to unlock discounts*
        </p>
        <BulletText />
        <Shelf>
          <WhiteLabelButton classNames={styles.CtaButton} onClick={() => showModal(RequestTypes.print)} icon="print" text="Print Card" />
          <WhiteLabelButton
            classNames={styles.CtaButton}
            onClick={() => showModal(RequestTypes.email)}
            icon="envelope"
            text="Email Card"
          />
          <WhiteLabelButton
            classNames={styles.CtaButton}
            onClick={() => showModal(RequestTypes.text)}
            icon="message-dots"
            text="Text Card"
          />
        </Shelf>
        <Body size="small">*This savings program is not health insurance and cannot be used in conjunction with insurance.
          The range of discounts for prescription services provided under the card will vary depending on the type of pharmacy and medication
          received. Plan member is obligated to pay for all prescriptions, but will receive a discount from those pharmacies that have
          contracted with the discount card.</Body>
      </Stack>
      <Image src={card} alt="discount card image" />
    </Shelf>
  );
};
